// Checkbox mit data-depends-on="<Name>": nur wählbar, solange die Checkbox
// dieses Namens im selben Formular angehakt ist - etwa „Danach Domains taggen“
// unter der Bewertungs-KI. Mit data-depends-on="<Name>=<Wert>" hängt sie an
// einer Auswahl (Radio): wählbar, solange dieser Wert gewählt ist - etwa die
// Tenants eines neuen Verwaltungsnutzers. Der Haken bleibt beim Sperren stehen
// und gilt wieder, sobald die übergeordnete Auswahl zurückkommt. Ohne
// JavaScript entscheidet der Server.
export default function dependsOn() {
  document.querySelectorAll('input[type=checkbox][data-depends-on]').forEach(function (input) {
    if (!input.form || input.disabled) return;
    const [name, value] = input.dataset.dependsOn.split('=');
    const type = value === undefined ? 'checkbox' : 'radio';
    const masters = Array.from(input.form.elements).filter(function (el) {
      return el.type === type && el.name === name;
    });
    if (masters.length === 0) return;

    const wrapper = input.closest('.check');
    const sync = function () {
      input.disabled = !masters.some(function (el) {
        return el.checked && !el.disabled && (value === undefined || el.value === value);
      });
      if (wrapper) wrapper.classList.toggle('is-disabled', input.disabled);
    };
    masters.forEach(function (el) {
      el.addEventListener('change', sync);
    });
    sync();
  });
}
